function applyToEl(el, styles, classes) {
  Object.entries(styles).forEach(([property, value]) => {
    el.style[property] = value;
  })

  classes.forEach((cls) => {
    el.classList.add(cls);
  })
}

export default function (shouldApply, rowElement, cellElement, params) {

  Object.values(params).forEach(({ rowStyles, rowClasses, cellStyles, cellClasses, ...params }) => {
    if (shouldApply(params)) {
      applyToEl(rowElement, rowStyles, rowClasses);
      applyToEl(cellElement, cellStyles, cellClasses);
    }
  })
}